import { FC, useMemo } from "react";
import { IUserData } from "../../common/interfaces/user.interface";
import { whitelistingStatusColor } from "../../utils/constants";

const WhitelistingStatusChip: FC<{ user: IUserData }> = ({ user }) => {
  const getWhitelistingColors = useMemo(() => {
    if (user) return whitelistingStatusColor.get(user.whitelisting.status);
  }, [user]);

  return (
    <div
      style={{
        padding: "0.75em",
        backgroundColor: getWhitelistingColors![0],
        borderRadius: "8px",
        textAlign: "center",
      }}
    >
      <p
        style={{
          color: getWhitelistingColors![1],
          textTransform: "capitalize",
          fontWeight: "500",
        }}
      >
        {user.whitelisting.status}
      </p>
    </div>
  );
};

export default WhitelistingStatusChip;
